import { Dispatch } from "redux";

import { KYCDispatchType, KYC_REDIRECT_URL } from "./KYCActionType";

export const SetRedirectURL =
  (url?: string) => (dispatch: Dispatch<KYCDispatchType>) => {
    try {
      dispatch({
        type: KYC_REDIRECT_URL,
        payload: {
          redirectUrl: url,
        },
      });
    } catch (e) {
      dispatch({
        type: KYC_REDIRECT_URL,
        payload: {
          redirectUrl: undefined,
        },
      });
    }
  };
